import { render, staticRenderFns } from "./TabsComponent.vue?vue&type=template&id=2711fa5f&scoped=true&"
import script from "./TabsComponent.vue?vue&type=script&lang=js&"
export * from "./TabsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TabsComponent.vue?vue&type=style&index=0&id=2711fa5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2711fa5f",
  null
  
)

export default component.exports